import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { getCompanies, getUser } from '../../../reducers';
import Chat from '../Chat';
import * as Constants from '../../../constants';
import './styles.css';

import procedure_icon from '../../../images/procedure_icon_yellow.png';

function compareDateHour( a, b ) {
    const hourA = moment(a.createDate, 'HH:mm DD/MM/YYYY');
    const hourB = moment(b.createDate, 'HH:mm DD/MM/YYYY');
    if ( hourA.isAfter(hourB) ) {
      return -1;
    }
    if ( hourA.isBefore(hourB) ) {
      return 1;
    }
    return 0;
};

const Chats = props => {

    const[selectedProcedureId, setSelectedProcedureId] = useState(null)

    const renderCompanyName = companyId => {
        return (props.companies && props.companies[companyId] && props.companies[companyId].name) ? props.companies[companyId].name : "Empresa"
    }

    const renderProcedureType = category => {
        const categorySplit = category.split("_")
        return `${categorySplit?.[(categorySplit.length - 2)]} - ${categorySplit?.[(categorySplit.length - 1)]}`
    }

    const renderProcedureState = state => {
        switch (state) {
            case "PENDING":
                return "Pendiente";
            case "FINISHED":
                return "Finalizada";
            default:
                return "Pendiente";
        }
    }

    const getProceduresSorted = procedures => {
        var proceduresArray = Object.values(procedures);
        proceduresArray.sort(compareDateHour);
        return proceduresArray;
    }

    const areUnseenMessages = (procedure) => {
        var messagesWereSeen = false
        if(procedure.state === Constants.procedureStateType.PENDING && procedure.chat && procedure.chat.messages) {
            Object.values(procedure.chat.messages).forEach(message => {
                if(!isMyMessage(message.senderId, procedure.userId, props.user.id) && !message.wasSeen) {
                    messagesWereSeen = true
                }
            });
        }
        return messagesWereSeen
    }

    const isMyMessage = (senderId, clientId, uid) => {
        if (uid === senderId) {
            return true
        } else {
            return (senderId !== clientId && uid !== clientId)
        }
    }

    return (
        <Grid className="ChatsCont">
            <Row className="rowChatsCont">
                <Col xs={6} md={6} lg={5} xl={4} className="listChatsContainer">
                    {
                        Object.keys(props.procedures).length === 0 ?
                            <div className="emptyChatsCont">
                                <Empty description="No hay chats disponibles" />
                            </div>
                            :
                            <div className="itemsChat">
                                {
                                    getProceduresSorted(props.procedures).map(procedure => {
                                        const isSelected = (selectedProcedureId === procedure.id)
                                        return (
                                            <div key={procedure.id}>
                                                <div onClick={() => setSelectedProcedureId(procedure.id)} className={`itemChat${isSelected ? "Selected" : ""} ${areUnseenMessages(procedure) ? "itemChatWithNotification" : ""}`}>
                                                    <Row>
                                                        <Col xs={2} className="itemChatImageCon">
                                                            <img src={procedure_icon} alt="Chat" className="itemChatImage"/>
                                                        </Col>
                                                        <Col xs={10}>
                                                            <h2 className="itemChatCompanyName">{renderCompanyName(procedure.companyId)}</h2>
                                                            <h4 className="itemChatProcedureType">Trámite: {renderProcedureType(procedure.category)}</h4>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={6}>
                                                            <h4 className="itemChatProcedureState">{renderProcedureState(procedure.state)}</h4>
                                                        </Col>
                                                        <Col xs={6}>
                                                            <h4 className="itemChatProcedureCustomId">ID: {procedure.customID}</h4>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={12}>
                                                            <h4 className="itemChatProcedureUserName">Cliente: {procedure.userName}</h4>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <hr className="itemChatDividerBottom" />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                    }
                </Col>
                {
                    selectedProcedureId ?
                        <Col xs={6} md={6} lg={7} xl={8} className="chatContainer">
                            <Chat procedure={props.procedures[selectedProcedureId]} user={props.user} enableChat={props.enableChat} />
                        </Col>
                        :
                        <Col xs={6} md={6} lg={7} xl={8} className="chatContainer"></Col>
                }
            </Row>
        </Grid>
    );
};

Chats.propTypes = {
    procedures: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
    companies:  getCompanies(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(Chats));